<template>
    <div class="index">
        <!-- 导航栏 -->
        <div class="topNav">
            <div class="nav-box">
                <img class="nav-image" src="../../assets/index/logo.png">
                <span class="nav-title">山东省泰山教育创新研究院技能等级考试系统</span>
            </div>
        </div>

        <!-- 主页 -->
        <div class="index-view">
            <div class="index-search">
                <div class="search-title">考生报名</div>
                <div class="input-item">
                    <div class="name-view">姓名</div>
                    <div class="name-view-txt">:</div>
                    <input v-model="name" class="input-view" type="text" placeholder="请输入姓名" @input="changeName">
                    <div class="warn-view" v-if="nameRule == true">请填写姓名</div>
                </div>

                <div class="input-item">
                    <div class="name-view">性别</div>
                    <div class="name-view-txt">:</div>
                    <el-select v-model="sex" placeholder="请选择性别" @input="changeSex">
                        <el-option
                            v-for="item in sexList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="warn-view" v-if="sexRule == true">请选择性别</div>
                </div>

                <div class="input-item">
                    <div class="name-view">身份证号</div>
                    <div class="name-view-txt">:</div>
                    <input v-model="card" class="input-view" type="text" placeholder="请输入身份证号" @input="changeCard">
                    <div class="warn-view" v-if="cardRule == true">请填写身份证号</div>
                </div>

                <div class="input-item">
                    <div class="name-view2">报考技能类别及等级</div>
                    <div class="name-view-txt">:</div>
                    <el-select v-model="type" placeholder="请选择报考技能类别及等级" @input="changeType">
                        <el-option
                            v-for="item in  typeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="warn-view" v-if="typeRule == true">请选择报考技能类别及等级</div>
                </div>

                <div class="input-item">
                    <div class="name-view">联系电话</div>
                    <div class="name-view-txt">:</div>
                    <input v-model="phone" class="input-view" type="number" placeholder="请输入联系电话" @input="changePhone">
                    <div class="warn-view" v-if="phoneRule == true">请填写联系电话</div>
                </div>

                <div class="input-item">
                    <div class="name-view">邮寄地址</div>
                    <div class="name-view-txt">:</div>
                    <input v-model="address" class="input-view" placeholder="请输入邮寄地址" @input="changeAddress">
                    <div class="warn-view" v-if="addressRule == true">请填写邮寄地址</div>
                </div>

            </div>

            <!-- 考试按钮 -->
            <div class="button-view" @click="toSign">立即报名</div>

            <!-- 遮罩层弹窗 -->
            <div class="cover-box" v-if="coverShow == true">
                <div class="cover-box-item">
                    <p>{{ text }}</p>
                    <div class="close-button" @click="closeCover"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                sexList: [
                    {
                        id: 1,
                        name: '男'
                    },
                    {
                        id: 2,
                        name: '女'
                    }
                ],
                typeList: [
                    {
                        id: 1,
                        name: '互联网营销师五级(初级)'
                    },
                    {
                        id: 2,
                        name: '互联网营销师四级(中级)'
                    },
                    {
                        id: 3,
                        name: '互联网营销师三级(高级)'
                    },
                    {
                        id: 4,
                        name: '家庭教育指导师五级(初级)'
                    },
                    {
                        id: 5,
                        name: '家庭教育指导师四级(中级)'
                    },
                    {
                        id: 6,
                        name: '家庭教育指导师三级(高级)'
                    }
                ],

                name: '',
                sex: '',
                card: '',
                type: '',
                phone: '',
                address: '',

                nameRule: false,
                sexRule: false,
                cardRule: false,
                typeRule: false,
                phoneRule: false,
                addressRule: false,

                coverShow: false,
                text: ''

            }
        },
        methods: {
            toSign() {
                if(this.name == '' || this.sex == '' || this.card == '' || this.type == '' || this.phone == '' || this.address == '') { 
                    if(this.name == '') {
                        this.nameRule = true 
                    }
                    if(this.sex == '') {
                        this.sexRule = true 
                    }
                    if(this.card == '') {
                        this.cardRule = true 
                    }
                    if(this.type == '') {
                        this.typeRule = true 
                    }
                    if(this.phone == '') {
                        this.phoneRule = true 
                    }
                    if(this.address == '') {
                        this.addressRule = true 
                    }
                    
                } else  {
                    this.http.post('/signUp/doSignUp', {
                        username: this.name,
                        idNo: this.card,
                        level: this.type,
                        sex: this.sex,
                        phone: this.phone,
                        address: this.address
                    }).then(res=> {
                        if(res.data.code == 0) {
                            this.text = '报名成功！'
                            this.coverShow = true
                            this.clean()
                        } else {
                            this.text = '报名失败，请重试！'
                            this.coverShow = true
                        }
                    }) 
                   
                }
               
            },
            clean() {
                this.name = ''
                this.sex = ''
                this.card = ''
                this.type = ''
                this.phone = ''
                this.address = ''
            },
            changeName() {
                this.nameRule = false
            },
            changeSex() {
                this.sexRule = false
            },
            changeCard() {
                this.cardRule = false
            },
            changeType() {
                this.typeRule = false
            },
            changePhone() {
                this.phoneRule = false
            },
            changeAddress() {
                this.addressRule = false
            },
            
            closeCover() {
                this.coverShow = false
            }
        }
    }
</script>

<style lang="less" scoped>
    .index {
        width: 100%;
        min-height: 100vh;
        background: #368FCE;
        padding-bottom: 80px;
        box-sizing: border-box;
        .topNav {
            width: 100%;
            height: 100px;
            background-color: #fff;
            .nav-box {
                width: 100%;
                padding: 20px 140px;
                box-sizing: border-box;
                display: flex;
                .nav-image {
                    width: 35px;
                    height: 35px;
                    margin-top: 8px;
                }
                .nav-title {
                    margin-left: 11px;
                    font-size: 36px;
                    font-weight: 500;
                    color: #368FCE;
                }
                
            }
        
        }
        .index-view {
            padding-top: 50px;
            box-sizing: border-box;
        }
        .index-search {
            width: 1200px;
            margin: 0 auto;
            background-color: #FFFFFF;
            border-radius: 15px;
            padding:30px 91px 50px 60px;
            box-sizing: border-box;
            .search-title {
                font-size: 40px;
                font-weight: 500;
                color: #333333;
                text-align: center;
            }
            .input-item {
                width: 100%;
                display: flex;
                margin-top: 25px;
                margin-bottom: 40px;
                position: relative;
                .name-view {
                    width: 120px;
                    margin-left: 180px;
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 63px;
                    text-align-last: justify;
                }
                .name-view2 {
                    margin-left: 50px;
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 63px;
                    text-align-last: justify;
                }
                .name-view-txt {
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 63px;
                    margin-left: 10px;
                }
                .input-view {
                    margin-left: 20px;
                    width: 644px;
                    height: 63px;
                    border-radius: 8px;
                    border: 3px solid #333333;
                    padding: 0 30px;
                    font-size: 26px;
                    font-weight: 500;
                    color: #333333;
                }
                input::-webkit-input-placeholder {
                    color: #c5c5c5;
                }
                .warn-view {
                    position: absolute;
                    top: 70px;
                    left: 358px;
                    font-size: 20px;
                    font-weight: 500;
                    color: #E02020;
                }
                // /deep/.el-select {
                //     margin-left: 20px;
                //     width: 644px;
                //     height: 63px;
                //     border-radius: 8px;
                //     border: 3px solid #333333;
                //     padding: 0 30px;
                //     font-size: 26px;
                //     font-weight: 500;
                //     color: #333333;
                // }
                /deep/ .el-input {
                    margin-left: 20px;
                    width: 644px;
                    height: 63px;
                    border-radius: 8px;
                    border: 3px solid #333333;
                    padding: 0 30px;
                    font-size: 26px;
                    font-weight: 500;
                    color: #333333;
                }
                /deep/ .el-input__inner {
                    border: none;
                    height: 63px;
                    font-weight: 400;
                    color: #333333;
                    padding: 0;
                }
                /deep/.el-select .el-input .el-select__caret {
                    font-size: 26px;
                    color: #333333;
                    line-height: 58px;
                    margin-right: 10px;
                }
                
            }
            
        }
        .button-view {
            margin: 0 auto;
            margin-top: 40px;
            width: 1200px;
            height: 120px;
            background: #FFFFFF;
            border-radius: 15px;
            font-size: 40px;
            font-weight: 500;
            color: #368FCE;
            line-height: 120px;
            text-align: center;
            cursor: pointer;
        }


        .cover-box {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.45);
            z-index: 999;
            .cover-box-item {
                text-align: center;
                width: 700px;
                background: #FFFFFF;
                border-radius: 15px;
                margin: 0 auto;
                margin-top: 250px;
                padding: 40px 60px;
                box-sizing: border-box;
                position: relative;
                font-size: 40px;
                .close-button {
                    position: absolute;
                    width: 68px;
                    height: 68px;
                    background-image: url('../../assets/index/close.png');
                    background-size: 100% 100%;
                    top: -86px;
                    right: -86px;
                    cursor: pointer;
                }
            }
            
            
        } 
    }
</style>